( function () {
	'use strict';

	const showsDateTimeToFormat = document.querySelectorAll( '.transform-show-date' );

	showsDateTimeToFormat.forEach( ( element ) => {
		showsFormatDateTime( element );
	} );

	/**
	 * Apply Date format on the element.
	 */
	function showsFormatDateTime( element ) {

		const rawDate = element?.getAttribute( 'data-show-date' )?.trim() ?? '';
		const rawTime = element?.getAttribute( 'data-show-time' )?.trim() ?? '';

		// Ensure time is in HH:MM:SS format
		const [ hour, minute, second ] = rawTime.split( ':' ).map( part => part.padStart( 2, '0' ) );
		const formattedTime = `${ hour }:${ minute }:${ second }`;

		// Combine with time in ISO format
		const suppliedDate = new Date( `${ rawDate }T${ formattedTime }` );

		// Get the 12-hour formatted time (h:mm AM/PM)
		const formattedTimeWithAMPM = suppliedDate.toLocaleTimeString( 'en-US', {
			hour12: true,
			hour: 'numeric',
			minute: '2-digit'
		} );

		// Determine if the date is "Today" or "Tomorrow"
		const today = new Date();
		today.setHours( 0, 0, 0, 0 );

		const tomorrow = new Date( today );
		tomorrow.setDate( today.getDate() + 1 );

		let dayOfWeek = suppliedDate.toLocaleDateString( 'en-US', { weekday: 'long' } );

		if ( suppliedDate.toDateString() === today.toDateString() ) {
			dayOfWeek = 'Today';
		} else if ( suppliedDate.toDateString() === tomorrow.toDateString() ) {
			dayOfWeek = 'Tomorrow';
		}

		element.textContent = dayOfWeek + ' ' + formattedTimeWithAMPM;
	}
} )();
